<template>
	<div class="form-elements">
		<div class="va-row">
			<div class="flex md12 xs12" style="padding-bottom:0;backgroundColor:#FFFFFF;">
				<vuestic-widget
					:headerText="'forms.inputs.appInfo' | translate"
					id="appInfoWrap"
				>
					<div class="va-row">
						<div class="flex xs12 md6" style="max-height:360px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md10">
								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('appName'), 'valid': isFormFieldValid('appName')}"
								>
									<div class="input-group">
										<input
											id="appNameInput"
											name="appName"
											data-vv-as="App Name"
											v-model="appForm.appName"
											maxlength="128"
											autocomplete="off"
											v-validate="'required'"
											required
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label class="control-label" for="appName">{{'createApp.appInfo.appName' | translate}}：</label>
										<i class="bar"></i>
										<small
											v-show="errors.has('appName')"
											class="help text-danger"
										>{{ errors.first('appName') }}</small>
									</div>
								</div>

								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('contactEmail'), 'valid': simpleEmailValid}"
								>
									<div class="input-group">
										<input
											id="contactEmail"
											name="contactEmail"
                      data-vv-as="Contact Email"
											autocomplete="off"
											v-model="appForm.contactEmail"
											maxlength="100"
											v-validate="'required|email'"
											required
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label
											class="control-label"
											for="contactEmail"
										>{{'createApp.appInfo.contactEmail' | translate}}：</label>
										<i class="bar" />
                    <small
											v-show="errors.has('contactEmail')"
											class="help text-danger"
										>{{ errors.first('contactEmail') }}</small>
									</div>
								</div>

								<div class="form-group">
									<div class="input-group">
										<input
											id="websiteUrl"
											name="website"
											data-vv-as="Name"
											autocomplete="off"
											maxlength="128"
                      :readonly="true"
											v-model="appForm.website"
										/>
										<label class="control-label" for="websiteUrl">{{'createApp.appInfo.website' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>

								<div class="form-group" style="margin-bottom:30px;">
									<vuestic-checkbox :label="$t('t.status') + '：'" v-model="checkbox.readonly" disabled/>
								</div>
								<div class="form-group" id="selectWrapper">
									<div class="input-group">
										<input
                      id="industry"
											:label="$t('createApp.appInfo.industry')"
											name="industry"
											:readonly="true"
											autocomplete="off"
											:value="queryIndustry"
										/>
										<label class="control-label" for="industry">{{'createApp.appInfo.industry' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
							</fieldset>
						</div>
						<!-- view 模式第一列 -->
						<div class="flex xs12 md6" v-else>
							<fieldset class="flex xs12 md10">
								<div class="form-group">
									<div class="input-group">
										<input
											id="appNameInput"
											name="appName"
											:readonly="true"
											:value="appForm.appName"
											autocomplete="off"
										/>
										<label class="control-label" for="appName">{{'createApp.appInfo.appName' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input
											id="contactEmail"
											name="contactEmail"
											autocomplete="off"
											:readonly="true"
											:value="appForm.contactEmail"
										/>
										<label
											class="control-label"
											for="contactEmail"
										>{{'createApp.appInfo.contactEmail' | translate}}：</label>
										<i class="bar" />
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input
											id="websiteUrl"
											name="website"
											:readonly="true"
											autocomplete="off"
											:value="appForm.website"
											v-validate="'url'"
										/>
										<label class="control-label" for="website">{{'createApp.appInfo.website' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group" style="margin-bottom:30px;">
								<vuestic-checkbox :label="$t('t.status') + '：'" v-model="checkbox.readonly" :readonly="true" />
								</div>
								<div class="form-group" id="selectWrapper">
									<div class="input-group">
										<input
                      id="industry"
											:label="$t('createApp.appInfo.industry')"
											name="industry"
											:readonly="true"
											autocomplete="off"
											:value="queryIndustry"
										/>
										<label class="control-label" for="industry">{{'createApp.appInfo.industry' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md6" style="max-height:360px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md10">
								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('appNameShort'), 'valid': isFormFieldValid('appNameShort')}"
								>
									<div class="input-group">
										<input
											id="appNameShortInput"
											name="appNameShort"
											data-vv-as="App Name Abbreviation"
											v-model="appForm.appNameShort"
											maxlength="12"
											autocomplete="off"
											v-validate="'required'"
											required
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label class="control-label" for="appNameShort">{{'createApp.appInfo.appNameShort' | translate}}：</label>
										<i class="bar"></i>
										<small
											v-show="errors.has('appNameShort')"
											class="help text-danger"
										>{{ errors.first('appNameShort') }}</small>
									</div>
								</div>
								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('managerName'), 'valid': isFormFieldValid('managerName')}"
								>
									<div class="input-group">
										<input
											id="managerNameInput"
											name="managerName"
											data-vv-as="Manager Name"
											v-model="appForm.managerName"
											maxlength="128"
											autocomplete="off"
											v-validate="'required'"
											required
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label
											class="control-label"
											for="managerName"
										>{{'createApp.appInfo.managerName' | translate}}：</label>
										<i class="bar"></i>
										<small
											v-show="errors.has('managerName')"
											class="help text-danger"
										>{{ errors.first('managerName') }}</small>
									</div>
								</div>
								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('cellPhone'), 'valid': isFormFieldValid('cellPhone')}"
								>
									<div class="input-group">
										<input
											id="cellPhone"
											name="cellPhone"
											data-vv-as="Cell Phone"
											autocomplete="off"
											maxlength="20"
											@input="updatePhoneStatus(!isOverseaMobileVaild(appForm.cellPhone))"
											@blur="updatePhoneStatus(!isOverseaMobileVaild(appForm.cellPhone))"
											v-model="appForm.cellPhone"
											v-validate="'required|verifyCellPhone'"
											required
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label
											class="control-label"
											for="cellPhone"
										>{{'createApp.appInfo.cellPhone' | translate}}：</label>
										<i class="bar"></i>
										<small v-show="errors.has('cellPhone')" class="help text-danger">{{ errors.first('cellPhone') }}</small>
									</div>
								</div>
								<div class="form-group" id="selectWrapper">
									<div class="input-group">
										<input
											:label="$t('createApp.appInfo.country')"
											name="country"
											:readonly="true"
											autocomplete="off"
											:value="queryCountry(appForm.country)"
										/>
										<label class="control-label" for="cellPhone">{{'createApp.appInfo.country' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input
											id="date-picker-time"
											autocomplete="off"
											v-model="appForm.createTime"
											:readonly="true"
										/>
										<label
											class="control-label"
											for="date-picker-time"
										>{{'createApp.appInfo.createTime' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
							</fieldset>
						</div>
						<!-- view 模式第二列 -->
						<div class="flex xs12 md6" v-else>
							<fieldset class="flex xs12 md10">
								<div class="form-group">
									<div class="input-group">
										<input
											id="appNameShortInput"
											name="appNameShort"
											:readonly="true"
											:value="appForm.appNameShort"
											autocomplete="off"
										/>
										<label class="control-label" for="appNameShort">{{'createApp.appInfo.appNameShort' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input
											id="managerNameInput"
											name="managerName"
											:readonly="true"
											:value="appForm.managerName"
											autocomplete="off"
										/>
										<label
											class="control-label"
											for="managerName"
										>{{'createApp.appInfo.managerName' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input
											id="cellPhone"
											name="cellPhone"
											:readonly="true"
											autocomplete="off"
											maxlength="17"
											:value="appForm.cellPhone"
										/>
										<label
											class="control-label"
											for="cellPhone"
										>{{'createApp.appInfo.cellPhone' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group" id="selectWrapper">
									<div class="input-group">
										<input
											:label="$t('t.country') + '：'"
											name="country"
											:readonly="true"
											autocomplete="off"
											:value="queryCountry(appForm.country)"
										/>
										<label class="control-label" for="cellPhone">{{'createApp.appInfo.country' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
								<div class="form-group">
									<div class="input-group">
										<input
											id="date-picker-time"
											autocomplete="off"
											v-model="appForm.createTime"
											:readonly="true"
										/>
										<label
											class="control-label"
											for="date-picker-time"
										>{{'createApp.appInfo.createTime' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
							</fieldset>
						</div>
					</div>
				<!-- </vuestic-widget>
			</div>

			<div class="flex md12 xs12" style="padding-top:0">
				<vuestic-widget
					id="appLogoShowWrapper"
				>  -->
					<div
						class="va-row"
						v-if="showFileUploadFg"
						:style="{marginTop: curMode === 'view' ? '-3rem' : '1rem'}"
					>
						<div class="flex xs12 md12">
							<form name="fileUpload">
								<div class="form-group">
									<label
										for="uploadAppLogo"
										v-if="curMode === 'view' && previewImage"
										class="control-label"
									>App Logo：</label>
									<div style="padding-right: 40px;" id="appLogoWrapper" v-if="curMode === 'config'">
										<label for="uploadAppLogo" class="control-label">App Logo：</label>
										<vuestic-file-upload
											id="uploadAppLogo"
											type="single"
											:file-types="'.png, .jpg, .jpeg, .gif'"
											v-model="appLogo"
											ref="fieldInput"
											@input="uploadFile"
                      :isShowDelete="true"
										/>
									</div>
									<div class="file-upload-item" v-if="previewImage">
										<img :src="previewImage" alt="App Logo" class="file-upload-item-image" />
									</div>
								</div>
							</form>
							<span class="pic-desc"><span aria-hidden="true" class="entypo entypo-info-circled"></span>The recommended size of the uploaded image: width 60~90 pixels, height 35~50 pixels.</span>
						</div>
					</div>
				</vuestic-widget>
			</div>

			<div class="flex md12 xs12" style="padding-top:0">
				<vuestic-widget
					:headerText="'forms.inputs.report2Send' | translate"
					id="fileShowWrapper"
				>
					<div class="va-row">
						<div class="flex xs12 md12">
							<fieldset>
							<div
								class="form-group with-icon-right"
								v-if="curMode === 'config'"
								:class="{'has-error': initmailsVaild, 'valid': isSuccessfulEmailValid}"
							>
								<div class="input-group">
									<textarea
										id="userEmails"
										name="userEmails"
										class="emailsTextArea"
										v-model="appForm.userEmails"
										v-validate="'required'"
										autocomplete="off"
										maxlength="255"
										rows="1"
										style="overflow:auto;"
										:style="marginTop"
										@input="resizeEmailLabel($event, !isSuccessfulEmailValid)"
										@blur="focusEmailLabel($event, !isSuccessfulEmailValid)"
										placeholder="email;email"
										required
									></textarea>
									<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
									<i class="fa fa-check valid-icon icon-right input-icon"></i>
									<label
										class="control-label"
										for="userEmails"
									>{{'forms.inputs.emailValidatedSuccess' | translate}}:</label>
									<i class="bar"></i>
									<small
										v-show="initmailsVaild"
										class="help text-danger"
									>{{ mailsInfoMsg || errors.first('userEmails') }}</small>
									<label>{{ $t('t.youCanAddUp') }}</label>
								</div>
							</div>
							<div class="form-group" v-else>
								<div class="input-group">
									<textarea
										id="userEmails"
										name="userEmails"
										v-model="appForm.userEmails"
										autocomplete="off"
										maxlength="255"
										rows="1"
										:readonly="true"
										style="overflow:auto;"
										:style="marginTop"
										placeholder
									></textarea>
									<label
										class="control-label"
										for="userEmails"
									>{{'forms.inputs.emailValidatedSuccess' | translate}}：</label>
									<i class="bar"></i>
								</div>
							</div>
							</fieldset>
						</div>
					</div>
				</vuestic-widget>
			</div>

			<div class="flex md12 xs12" style="padding-top:0">
				<vuestic-widget :headerText="'forms.inputs.configs' | translate">
					<div class="va-row">
						<div class="flex xs12 md6" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md10">
								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('midInput'), 'valid': isFormFieldValid('midInput')}"
								>
									<div class="input-group">
										<input
											id="midInput"
											name="midInput"
											data-vv-as="Name"
											v-model="appForm.tid"
											autocomplete="off"
											v-validate="'required'"
											required
                      :readonly="true"
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label class="control-label" for="midInput">{{'createApp.configs.mid' | translate}}：</label>
										<i class="bar"></i>
										<small
											v-show="errors.has('midInput')"
											class="help text-danger"
										>{{ errors.first('midInput') }}</small>
									</div>
								</div>
							</fieldset>
						</div>
						<!-- view 模式第三列 -->
						<div class="flex xs12 md6" style="max-height:266px" v-else>
							<fieldset class="flex xs12 md10">
								<div class="form-group">
									<div class="input-group">
										<input
											id="midInput"
											name="midInput"
											:readonly="true"
											v-model="appForm.tid"
											autocomplete="off"
										/>
										<label class="control-label" for="midInput">{{'createApp.configs.mid' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md6" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md10">
								<div
									class="form-group with-icon-right"
									:class="{'has-error': errors.has('appId'), 'valid': isFormFieldValid('appId')}"
								>
									<div class="input-group">
										<input
											id="appId"
											name="appId"
											data-vv-as="Name"
											v-model="appForm.appId"
											autocomplete="off"
											v-validate="'required'"
											required
                      :readonly="true"
										/>
										<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
										<i class="fa fa-check valid-icon icon-right input-icon"></i>
										<label class="control-label" for="appId">{{'createApp.configs.appId' | translate}}：</label>
										<i class="bar"></i>
										<small v-show="errors.has('appId')" class="help text-danger">{{ errors.first('appId') }}</small>
									</div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md6" v-else>
							<fieldset class="flex xs12 md10">
								<div class="form-group">
									<div class="input-group">
										<input
											id="appId"
											name="appId"
											data-vv-as="Name"
											v-model="appForm.appId"
											:readonly="true"
											autocomplete="off"
										/>
										<label class="control-label" for="appId">{{'createApp.configs.appId' | translate}}：</label>
										<i class="bar"></i>
									</div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md12" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.securityKey" -->
										<textarea
											id="securityKey"
											name="securityKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isSecurityKeyOpen ? appForm.securityKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="securityKey"
										>{{'createApp.configs.securityKey' | translate}}：</label>
										<i class="bar"></i>
									</div>
                  <div v-if="isAdmin" class="d-flex" style="flex-direction: column;">
                    <div
                      class="btn btn-micro btn-primary btn-with-icon mb-2"
                      @click="getLastMerchantKey('MerchantPrivateKey', 'isSecurityKeyOpen')"
                    >
                      <div class="btn-with-icon-content" id="btn-ico-wrapper">
                        <i class="ico ico-md-entypo entypo-cw"></i>
                        <div class="centerFont">{{'buttons.update' | translate}}</div>
                      </div>
                    </div>
                    <button :disabled="isCopySuccess" class="btn btn-info btn-micro btn-with-icon mr-2" @click="copyText(appForm.securityKey)" v-if="isSecurityKeyOpen">
                      {{ $t('t.copy') }}
                    </button>
                  </div>
                  <div class="eye-password" style="left:100px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isSecurityKeyOpen', true, 'securityKey')" v-if="!isSecurityKeyOpen"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isSecurityKeyOpen', false, 'securityKey')" v-if="isSecurityKeyOpen"/>
                  </div>
								</div>
							</fieldset>
						</div>
						<!-- view 模式第三列 -->
						<div class="flex xs12 md6" style="max-height:266px" v-else>
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.securityKey" -->
										<textarea
											id="securityKey"
											name="securityKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isSecurityKeyOpen ? appForm.securityKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="securityKey"
										>{{'createApp.configs.securityKey' | translate}}：</label>
										<i class="bar"></i>
									</div>
                  <div class="eye-password d-flex" style="left:100px;" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isSecurityKeyOpen', true, 'securityKey')" v-if="!isSecurityKeyOpen"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isSecurityKeyOpen', false, 'securityKey')" v-if="isSecurityKeyOpen"/>
                    <el-tooltip v-if="isSecurityKeyOpen" class="item" effect="light" content="Copy" placement="top">
                      <img class="ml-1" :src="copyIcon" alt="" @click="copyText(appForm.securityKey)"/>
                    </el-tooltip>
                  </div>
								</div>
							</fieldset>
						</div>

						<!-- md5_key 20240617[页面MD5那个可以顺道也去掉了，1.0已经完全下线，用不到了] -->
						<!-- <div class="flex xs12 md12" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
										<textarea
											id="MD5Key"
											name="MD5Key"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isMD5KeyOpen ? appForm.md5Key : '******'"
										></textarea>
										<label
											class="control-label"
											for="MD5Key"
										>{{'createApp.configs.md5Key' | translate}}：</label>
										<i class="bar"></i>
									</div>
									<div
                    v-if="isAdmin"
										class="btn btn-micro btn-primary btn-with-icon mb-2"
										@click="getLastMerchantKey('MD5Key', 'isMD5KeyOpen')"
									>
										<div class="btn-with-icon-content" id="btn-ico-wrapper">
											<i class="ico ico-md-entypo entypo-cw"></i>
											<div class="centerFont">{{'buttons.update' | translate}}</div>
										</div>
									</div>
                  <div class="eye-password" style="left:75px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isMD5KeyOpen', true, 'md5Key')" v-if="!isMD5KeyOpen"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isMD5KeyOpen', false, 'md5Key')" v-if="isMD5KeyOpen"/>
                  </div>
								</div>
							</fieldset>
						</div> -->
						<!-- view 模式第三列 -->
						<!-- <div class="flex xs12 md6" style="max-height:266px" v-else>
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
										<textarea
											id="MD5Key"
											name="MD5Key"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isMD5KeyOpen ? appForm.md5Key : '******'"
										></textarea>
										<label
											class="control-label"
											for="MD5Key"
										>{{'createApp.configs.md5Key' | translate}}：</label>
										<i class="bar"></i>
									</div>
                  <div class="eye-password" style="left:75px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isMD5KeyOpen', true, 'md5Key')" v-if="!isMD5KeyOpen"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isMD5KeyOpen', false, 'md5Key')" v-if="isMD5KeyOpen"/>
                  </div>
								</div>
							</fieldset>
						</div> -->

						<div class="flex xs12 md12" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.publicKey" -->
										<textarea
											id="publicKey"
											name="publicKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isPublicKeyOpen ? appForm.publicKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="publicKey"
										>{{'createApp.configs.publicKey' | translate}}：</label>
										<i class="bar"></i>
									</div>
                  <div v-if="isAdmin" class="d-flex" style="flex-direction: column;">
                    <div class="btn btn-micro btn-primary btn-with-icon mb-2"
                      @click="getLastMerchantKey('MerchantPublicKey', 'isPublicKeyOpen')"
                    >
                      <div class="btn-with-icon-content" id="btn-ico-wrapper">
                        <i class="ico ico-md-entypo entypo-cw"></i>
                        <div class="centerFont">{{'buttons.update' | translate}}</div>
                      </div>
                    </div>
                    <button :disabled="isCopySuccess" class="btn btn-info btn-micro btn-with-icon mr-2" @click="copyText(appForm.publicKey)" v-if="isPublicKeyOpen">
                      {{ $t('t.copy') }}
                    </button>
                  </div>
                  <div class="eye-password" style="left:95px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isPublicKeyOpen', true, 'publicKey')" v-if="!isPublicKeyOpen"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isPublicKeyOpen', false, 'publicKey')" v-if="isPublicKeyOpen"/>
                  </div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md6" v-else>
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.publicKey" -->
										<textarea
											id="publicKey"
											name="publicKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isPublicKeyOpen ? appForm.publicKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="publicKey"
										>{{'createApp.configs.publicKey' | translate}}：</label>
										<i class="bar"></i>
									</div>
                  <div class="eye-password d-flex" style="left:95px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isPublicKeyOpen', true, 'publicKey')" v-if="!isPublicKeyOpen"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isPublicKeyOpen', false, 'publicKey')" v-if="isPublicKeyOpen"/>
                    <el-tooltip v-if="isPublicKeyOpen" class="item" effect="light" content="Copy" placement="top">
                      <img class="ml-1" :src="copyIcon" alt="" @click="copyText(appForm.publicKey)"/>
                    </el-tooltip>
                  </div>
								</div>
							</fieldset>
						</div>

            <!-- Merchant RSA Public Key -->
						<div class="flex xs12 md12" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.publicKey" -->
										<textarea
											id="publicKey"
											name="publicKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isMerchantRsaPublicKey ? appForm.mRsaPublicKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="publicKey"
										>Merchant RSA Public Key：</label>
										<i class="bar"></i>
									</div>
                  <div v-if="isAdmin" class="d-flex" style="flex-direction: column;">
                    <div class="btn btn-micro btn-primary btn-with-icon mb-2"
                      @click="getLastMerchantKey('MerchantRsaPublicKey', 'isMerchantRsaPublicKey')"
                    >
                      <div class="btn-with-icon-content" id="btn-ico-wrapper">
                        <i class="ico ico-md-entypo entypo-cw"></i>
                        <div class="centerFont">{{'buttons.update' | translate}}</div>
                      </div>
                    </div>
                    <button :disabled="isCopySuccess" class="btn btn-info btn-micro btn-with-icon mr-2" @click="copyText(appForm.mRsaPublicKey)" v-if="isMerchantRsaPublicKey">
                      {{ $t('t.copy') }}
                    </button>
                  </div>
                  <div class="eye-password" style="left:180px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isMerchantRsaPublicKey', true, 'mRsaPublicKey')" v-if="!isMerchantRsaPublicKey"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isMerchantRsaPublicKey', false, 'mRsaPublicKey')" v-if="isMerchantRsaPublicKey"/>
                  </div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md6" v-else>
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.publicKey" -->
										<textarea
											id="publicKey"
											name="publicKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isMerchantRsaPublicKey ? appForm.mRsaPublicKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="publicKey"
										>Merchant RSA Public Key：</label>
										<i class="bar"></i>
									</div>
                  <div class="eye-password d-flex" style="left:180px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isMerchantRsaPublicKey', true, 'mRsaPublicKey')" v-if="!isMerchantRsaPublicKey"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isMerchantRsaPublicKey', false, 'mRsaPublicKey')" v-if="isMerchantRsaPublicKey"/>
                    <el-tooltip v-if="isMerchantRsaPublicKey" class="item" effect="light" content="Copy" placement="top">
                      <img class="ml-1" :src="copyIcon" alt="" @click="copyText(appForm.mRsaPublicKey)"/>
                    </el-tooltip>
                  </div>
								</div>
							</fieldset>
						</div>

            <!-- VUE_APP_NAME RSA Public Key -->
						<div class="flex xs12 md12" style="max-height:266px" v-if="curMode === 'config'">
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.publicKey" -->
										<textarea
											id="publicKey"
											name="publicKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isPagsmileRsaPublicKey ? appForm.psPublicKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="publicKey"
										>{{ VUE_APP_NAME }} RSA Public Key：</label>
										<i class="bar"></i>
									</div>
                  <div v-if="isAdmin" class="d-flex" style="flex-direction: column;">
                    <div class="btn btn-micro btn-primary btn-with-icon mb-2"
                      @click="getLastMerchantKey('PagsmileRsaPublicKey', 'isPagsmileRsaPublicKey')"
                    >
                      <div class="btn-with-icon-content" id="btn-ico-wrapper">
                        <i class="ico ico-md-entypo entypo-cw"></i>
                        <div class="centerFont">{{'buttons.update' | translate}}</div>
                      </div>
                    </div>
                    <button :disabled="isCopySuccess" class="btn btn-info btn-micro btn-with-icon mr-2" @click="copyText(appForm.psPublicKey)" v-if="isPagsmileRsaPublicKey">
                      {{ $t('t.copy') }}
                    </button>
                  </div>
                  <div class="eye-password" style="left:180px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isPagsmileRsaPublicKey', true, 'psPublicKey')" v-if="!isPagsmileRsaPublicKey"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isPagsmileRsaPublicKey', false, 'psPublicKey')" v-if="isPagsmileRsaPublicKey"/>
                  </div>
								</div>
							</fieldset>
						</div>

						<div class="flex xs12 md6" v-else>
							<fieldset class="flex xs12 md12">
								<div class="form-group eye-password-wrap">
									<div class="input-group">
                    <!-- v-model="appForm.publicKey" -->
										<textarea
											id="publicKey"
											name="publicKey"
											autocomplete="off"
											maxlength="255"
											rows="3"
											:readonly="true"
											style="overflow:auto;"
											:style="marginTop"
											placeholder
                      :value="isPagsmileRsaPublicKey ? appForm.psPublicKey : '******'"
										></textarea>
										<label
											class="control-label"
											for="publicKey"
										>{{ VUE_APP_NAME }} RSA Public Key：</label>
										<i class="bar"></i>
									</div>
                  <div class="eye-password d-flex" style="left:180px" v-if="isAdmin">
                    <img :src="closeEye" alt="" @click="showEyePassword('isPagsmileRsaPublicKey', true, 'psPublicKey')" v-if="!isPagsmileRsaPublicKey"/>
                    <img :src="openEye" alt="" @click="showEyePassword('isPagsmileRsaPublicKey', false, 'psPublicKey')" v-if="isPagsmileRsaPublicKey"/>
                    <el-tooltip v-if="isPagsmileRsaPublicKey" class="item" effect="light" content="Copy" placement="top">
                      <img class="ml-1" :src="copyIcon" alt="" @click="copyText(appForm.psPublicKey)"/>
                    </el-tooltip>
                  </div>
								</div>
							</fieldset>
						</div>

					</div>

					<div class="va-row" v-if="curMode === 'config'">
						<div class="flex xs12 md12">
							<div class="section-comfirm">
								<button
									class="btn btn-primary btn-sm comfirm-ok"
									id="confirmCreateApp"
									@click="appdata"
								>{{ $t("basic.button.confirm") }}</button>
								<button
									class="btn btn-secondary btn-sm comfirm-cel"
									id="cancelCreateApp"
									@click="backBtnPre"
								>{{ $t("basic.button.cancel") }}</button>
							</div>
						</div>
					</div>
				</vuestic-widget>
			</div>
		</div>

		<div class="flex xs12 md6 flex-center" v-if="isToastContent">
			<div class="toasted-container sample-toasted-container shrink">
				<div class="toasted vuestic-toast none default">
					<i class="fa" :class="toastIcon" v-if="toastIcon" />
					{{toastText}}
				</div>
			</div>
		</div>
		<button class="btn btn-primary focus btn-sm" id="appInfoBackBtn" @click="goBack">{{ $t("back") }}</button>

    <vuestic-modal show.sync="true"
                   ref="passwordModal"
                   :okText="'modal.confirm2' | translate"
                   style="height: 100%;width:60vw;"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   alignModal=""
                   class="password-key-modal">
      <div slot="title">{{ $t("auth.password") }}</div>
      <div>
        <form onsubmit="return false">
          <div class="va-row">
            <div class="flex xs12 md12">
              <fieldset>
                <div class="form-group with-icon-right eye-password-modal"
                     :class="{'has-error': errors.has('validPassword'), 'valid': isFormFieldValid('validPassword')}">
                  <div class="input-group">
                    <input id="validPassword"
                           :type="isPasswordOpen?'text':'password'"
                           name="validPassword"
                           data-vv-as="Password"
                           v-model="validatePasswordBean.password"
                           autocomplete="off"
                           v-validate="'required'"
                           required
                           onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label"
                           for="validPassword">Password：</label>
                    <i class="bar"></i>
                    <div class="eye-password" v-if="isAdmin">
                      <img :src="closeEye" alt="" @click="() => { isPasswordOpen = true }" v-if="!isPasswordOpen"/>
                      <img :src="openEye" alt="" @click="() => { isPasswordOpen = false }" v-if="isPasswordOpen"/>
                    </div>
                    <small v-show="errors.has('validPassword')"
                           class="help text-danger">{{ errors.first('validPassword') }}</small>
                  </div>
                </div>
                <div class="form-group with-icon-right eye-password-modal" v-if="isShowMerchantPublicKeyTextarea" :class="{'has-error': errors.has('validateMerchantPublicKey'), 'valid': isFormFieldValid('validateMerchantPublicKey')}">
									<div class="input-group">
										<textarea
											id="validateMerchantPublicKey"
											name="validateMerchantPublicKey"
                      data-vv-as="Merchant Public Key"
											maxlength="2048"
											rows="3"
											style="overflow:auto;"
											:style="marginTop"
                      v-model="validatePasswordBean.merchantPublicKeyTextarea"
                      autocomplete="off"
                      v-validate="'required'"
                      required
                      onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')"
										></textarea>
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label"
                           for="validateMerchantPublicKey">Merchant Public Key：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('validateMerchantPublicKey')"
                           class="help text-danger">{{ errors.first('validateMerchantPublicKey') }}</small>
									</div>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>

	</div>
</template>

<script>
import {
  request,
  checkMobileOversea,
  exeTextLine,
  queryCountryByCode,
  checkEmail
} from '@/utils/utils.js'
export default {
  name: 'edit-app-info',
  data () {
    this.$validator.extend('verifyCellPhone', {
      validate: (value, ref) => {
        const status = checkMobileOversea(value)
        return status
      },
      getMessage: (field) => 'The ' + field + ' is not valid.'
    })
    return {
      viewFg: false,
      editFg: false,
      saveFg: false,
      appForm: {
        app_id: '',
        appName: '',
        appNameShort: '',
        contactEmail: '',
        website: '',
        managerName: '',
        cellPhone: '',
        country: '',
        userEmails: '',
        tid: '',
        secretWord: '',
        appId: '',
        securityKey: '',
        md5Key: '',
        publicKey: '',
        mRsaPublicKey: '',
        psPublicKey: '',
        createTime: '2018-05-08 14:10',
        status: true,
        industry: '',
      },
      appConfig: {

      },
      checkbox: {
        readonly: false
      },
      paddTop: {
        'padding-top': '18px'
      },
      marginTop: {
        'margin-top': '22px'
      },
      countryOptions: [
        {
          id: 1,
          description: 'China'
        },
        {
          id: 2,
          description: 'Brazil'
        },
        {
          id: 3,
          description: 'Mexico'
        }
      ],
      cellPhoneStatus: false,
      mailsStatus: false,
      countryStatus: false,
      isToastContent: false,
      toastIcon: 'fa-star-o',
      toastText: 'App has been created and completed!',
      toastPosition: 'top-center',
      isToastFullWidth: false,
      toastDuration: 2500,
      mailsInfoMsg: 'The userEmails field must be a valid email.',
      appLogo: [],
      previewImage: '',
      showTriggerFg: false,
      allRegions: [],
      industryOptions: [
        // Social
        { id: '1', value: 'Digital Content' },
        { id: '2', value: 'E-Commerce' },
        { id: '3', value: 'FX' },
        { id: '4', value: 'Game' },
        { id: '5', value: 'IT Technical Service' },
        { id: '6', value: 'Logistics' },
        { id: '7', value: 'Marketing' },
        { id: '8', value: 'Service' },
        { id: '9', value: 'Securities Dealer' },
        { id: '10', value: 'PSP (Internal)' },
        { id: '11', value: 'PSP' },
        { id: '12', value: 'Others' },
        { id: '13', value: 'Social' },
      ],
      closeEye: require('@/assets/images/eye-close.png'),
      openEye: require('@/assets/images/eye-open.png'),
      copyIcon: require('@/assets/images/copy.png'),
      isSecurityKeyOpen: false,
      isMD5KeyOpen: false,
      isPublicKeyOpen: false,
      isMerchantRsaPublicKey: false,
      isPagsmileRsaPublicKey: false,
      isShowMerchantPublicKeyTextarea: false,
      validatePasswordBean: { password: '', merchantPublicKeyTextarea: '' },
      isPasswordOpen: false,
      currentKey: '',
      isCopySuccess: false,
      VUE_APP_NAME: process.env.VUE_APP_NAME
    }
  },
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return 'mobile'
      }
      return 'pc'
    },
    isSuccessfulEmailValid () {
      // 255个字符，并且最多5个邮箱
      let isValid = false
      if (this.formFields.userEmails) {
        if (!this.appForm.userEmails) {
          return
        }
        if (this.appForm.userEmails.includes(';')) {
          let subEmails = this.appForm.userEmails.split(';')
          let results = []
          for (let j = 0; j < subEmails.length; j++) {
            if (subEmails[j] && subEmails[j] !== '') {
              checkEmail(subEmails[j]) ? results.push(1) : results.push(0)
            }
          }
          let fg = !(results.includes(0) || results.length > 5)
          if (results.length > 5) {
            this.mailsInfoMsg = 'You can only enter 5 email address at most.'
          } else if (results.includes(0)) {
            this.mailsInfoMsg = 'The userEmails field must be a valid email.'
          }
          isValid = fg
        } else {
          isValid =
						this.formFields.userEmails.validated &&
						this.formFields.userEmails.valid
        }
      }
      return isValid
    },
    simpleEmailValid () {
      let isValid = false
      if (this.formFields.contactEmail) {
        isValid =
					this.formFields.contactEmail.validated &&
					this.formFields.contactEmail.valid
      }
      return isValid
    },
    initPhoneVaild () {
      return this.cellPhoneStatus
    },
    initSelectedVaild () {
      return this.countryStatus
    },
    initmailsVaild () {
      return this.mailsStatus
    },
    curMode () {
      return this.viewFg ? 'view' : 'config'
    },
    showFileUploadFg () {
      let viewShowFg = this.curMode === 'view' && this.previewImage
      let configShowFg = this.curMode === 'config'
      return !!(viewShowFg || configShowFg)
    },
    queryIndustry () {
      let industry = this.industryOptions.filter(value => value.id === this.appForm.industry)[0]
      if (industry) {
        return industry.value
      }
      return ''
    },
    isAdmin: function() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const { data } = userInfo.info
        if (data.role === 'MERCHANT_ADMIN') {
          return true
        }
        return false
      } catch (error) {
        return false
      }
    }
  },
  created () {
    this.switMode()
    this.initDropdown()
  },
  mounted () {
    this.init()
    this.renderdata()
    exeTextLine('', 'emailsTextArea')
  },
  methods: {
    init () {
      if (this.$refs.myInput) {
        this.$refs.myInput.$el.getElementsByTagName('input')[0].readOnly = true
      }
      let wrapBody = document.querySelector('.vuestic-widget-body')
      wrapBody.offsetHeight === 54
        ? (document.getElementById('appInfoBackBtn').style.top = '106px')
        : (document.getElementById('appInfoBackBtn').style.top = '126px')
      if (this.isMobile === 'mobile') {
        let backBtn = document.getElementById('appInfoBackBtn')
        backBtn.style.top = '10px'
        backBtn.style.left = '5px'
        backBtn.style.padding = '5px 8px'
        backBtn.style.lineHeight = 1
      }
    },
    initDropdown () {
      let token = localStorage.getItem('Authorization')
      let url = '/api/dashboard/basic/getDropdown?access_token=' + token
      request({
        method: 'post',
        url
      }).then(res => {
        this.allRegions = res.data.regions
      })
    },
    queryCountry (code) {
      for (let i = 0; i < this.allRegions.length; i++) {
        if (this.allRegions[i].code === code) {
          return this.allRegions[i].name || queryCountryByCode(code)
          break
        }
      }
    },
    // 查询最新的更新的商户秘钥
    queryLastKey () {
      let token = localStorage.getItem('Authorization')
      let id = this.$route.params.app_id
      const param = {
        app_id: id
      }
      request({
        method: 'post',
        url: `api/dashboard/app/keys/reveal?access_token=${token}`,
        params: param,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          let code = res.status
          if (code == 200) {
            this.appForm.securityKey = res.data
          }
        })
        .catch(err => {
          console.log(err)
          /* this.toastText = err.msg
        this.launchToast() */
        })
    },
    // 选择查看还是congig 编辑模式
    switMode () {
      if (this.$route.path.includes('view')) {
        this.viewFg = true
      } else {
        this.editFg = true
      }
    },
    getLastMostForm () {
      var alterFg = this.checkAppConfig()
      if (alterFg) { // 如果App的config已经修改了，弹提示
        let token = localStorage.getItem('Authorization')
        let id = this.$route.params.app_id
        const param = {
          app_name: this.appForm.appName.trim().replace('\\u200B', ''),
		  		app_name_short: this.appForm.appNameShort.trim().replace('\\u200B', ''),
          contact: this.appForm.managerName.trim().replace('\\u200B', ''),
          contact_email: this.appForm.contactEmail,
          phone: this.appForm.cellPhone,
          region: this.appForm.country.description,
          report_email: this.appForm.userEmails,
          merchant_no: this.appForm.tid,
          app_id: id,
          industry: this.appForm.industry
        }
        this.appForm.website ? (param.index_url = this.appForm.website) : ''
        this.checkbox.readonly ? (param.status = 1) : (param.status = 0)
        this.appForm.publicKey
          ? (param.mpublic_key = this.appForm.publicKey)
          : ''
        this.$confirm(
          'This operation will save the modification of APP information. Are you sure?',
          'warning',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        )
          .then(() => {
						this.loadingFullScreen("updateAppLoading", "Loading", "fa fa-hourglass-half")
            request({
              method: 'post',
              url: `api/dashboard/app/update?access_token=${token}`,
              data: param,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(res => {
								this.updateAppLoading.close();
                let code = res.data.code
                if (code == 10000) {
                  this.$message({
                    type: 'success',
                    duration: 1800,
                    message: 'App information has been modified!'
                  })
                  let that = this
                  _.delay(function () {
                    that.$router.push({
                      name: 'AppManagement'
                    })
                  }, 2000)
                } else {
                  this.$message({
                    type: 'success',
                    duration: 1800,
                    message: 'App information modification failed!'
                  })
                }
              })
              .catch(err => {
								this.updateAppLoading.close();
                this.toastText = err.msg
                this.launchToast()
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Cancelled!'
            })
          })
      } else {

      }
    },
    // 查询 APP的信息
    renderdata () {
      let token = localStorage.getItem('Authorization')
      let id = this.$route.params.app_id
      let that = this
      request({
        method: 'post',
        url:
					'api/dashboard/app/queryById?app_id=' +
					id +
					'&access_token=' +
					token +
					'',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          console.log(res.data)
          that.cloneMostData(res.data.data)
          if (res.data.data.status !== '0') {
            that.$set(that.checkbox, 'readonly', true)
          } else {
            that.$set(that.checkbox, 'readonly', false)
          }
          that.convertToImg(res.data.data.icon_url)
          // that.queryLastKey()
        })
        .catch(err => {
          that.toastText = err.msg
          that.launchToast()
        })
    },
    // 给appForm 更新数据
    cloneMostData (obj) {
      this.appForm = Object.assign(
        {},
        {
          appId: obj.app_id || this.$route.params.app_id,
          appName: obj.app_name,
          appNameShort: obj.app_name_short,
          contactEmail: obj.contact_email,
          website: obj.index_url,
          managerName: obj.contact,
          cellPhone: obj.phone,
          country: obj.region,
          userEmails: obj.report_email,
          tid: obj.merchant_no,
          secretWord: obj.md5_key_word,
          // publicKey: obj.mpublic_key,
          // md5Key: obj.md5_key,
          // securityKey: obj.md5_key,
          createTime: obj.create_time,
          status: obj.status,
          industry: obj.industry
        }
      )
      this.appConfig = JSON.stringify(this.appForm)
    },
    // 上传App logo
    upLoadAppLogo () {
      let token = localStorage.getItem('Authorization')
      let id = this.$route.params.app_id
      const param = new FormData()
      if (this.appLogo.length > 0) {
        param.append('logo', this.appLogo[this.appLogo.length-1])
        this.saveFg = true
      } else {
        return
      }
      request({
        method: 'post',
        url: `api/dashboard/app/uploadLogo?app_id=${id}&access_token=${token}`,
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          let code = res.data.code
          if (code == 10000) {
            this.toastText = res.data.msg || 'Success!'
            this.launchToast()
          } else {
            this.toastText = res.data.msg
            this.launchToast()
          }
        })
        .catch(err => {
          this.toastText = err.msg
          this.launchToast()
        })
    },
    uploadFile (files) {
      let file = files[files.length-1]
      if (file) {
        this.convertToImg(file)
        this.upLoadAppLogo()
      } else {
        this.previewImage = ''
      }
    },
    convertToImg (file) {
      const reader = new FileReader()
      const imageFileTypes = ['/png', '/jpg', '/jpeg', '/gif']
      if (this._.isString(file)) {
        // 证明file 是 url
        this.previewImage = file
        return
      } else if (this._.isUndefined(file)) {
        this.previewImage = ''
        return
      }
      reader.readAsDataURL(file)
      reader.onload = e => {
        for (let i = 0; i < imageFileTypes.length; i++) {
          if (e.target.result.indexOf(imageFileTypes[i]) >= 0) {
            this.previewImage = e.target.result
          }
        }
      }
    },
    updatePhoneStatus (bol) {
      this.cellPhoneStatus = bol
    },
    updateMailsStatus (bol) {
      this.mailsStatus = bol
    },
    forbiddenInput (val) {
      if (!val) {
        this.$refs.myInput.$el.getElementsByTagName('input')[0].style.height =
					'28px'
        this.countryStatus = true
      } else {
        this.countryStatus = false
      }
    },
    readOnlyInput () {
      this.$refs.myInput.$el.getElementsByTagName('input')[0].readOnly = true
    },
    resizeEmailLabel (e, bol) {
      e.currentTarget.style.marginTop = '10px'
      this.updateMailsStatus(bol)
    },
    focusEmailLabel (e, bol) {
      e.currentTarget.style.marginTop = '22px'
      this.updateMailsStatus(bol)
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
					this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    isFormFieldValidisUrlValid (field) {
      let isValid = false
      if (checkUrl(field)) {
        isValid = true
      }
      return isValid
    },
    isOverseaMobileVaild (field) {
      let isValid = false
      if (checkMobileOversea(field)) {
        isValid = true
      }
      return isValid
    },
    isCountryVaild (field) {
      let isValid = false
      if (this.countryStatus) {
        isValid = true
      }
      return isValid
    },
    // 检测app config查询信息以后页面显示的数据是否变化
    checkAppConfig () {
      let appCfBaseFg = false
      var appShowInfo = {
        appName: this.appForm.appName,
        appNameShort: this.appForm.appNameShort,
        managerName: this.appForm.managerName,
        contactEmail: this.appForm.contactEmail,
        cellPhone: this.appForm.cellPhone,
        website: this.appForm.website,
        userEmails: this.appForm.userEmails,
        createTime: this.appForm.createTime,
        tid: this.appForm.tid,
        appId: this.appForm.appId,
        status: this.checkbox.readonly === true ? '1' : '0',
        industry: this.appForm.industry,
      }
      var queryAppData = JSON.parse(this.appConfig)
      for (let key in appShowInfo) {
        if (appShowInfo[key] !== queryAppData[key]) {
          appCfBaseFg = true
        }
      }
      if (appCfBaseFg || this.saveFg) {
        return true
      } else {
        return false
      }
    },
    goBack () {
      // 增加判断如果app config 修改了，需要提示用户已经做了修改是否放弃，需要弹窗确认
      if (location.pathname.indexOf('/edit') > 0) {
        this.$confirm(
          'This operation will discard your modification. Are you sure?',
          'warning',
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        )
          .then(() => {
            this.$message({
              type: 'warning',
              duration: 1800,
              message: 'You have given up modifying the App!'
            })
            let that = this
            _.delay(function () {
              that.$router.push({
                name: 'AppManagement'
              })
            }, 2000)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Cancelled!'
            })
          })
      } else {
        this.$router.push({
          name: 'AppManagement'
        })
      }
    },
    backBtnPre () {
      this.goBack()
    },
    // 提交用户新建APP的数据信息
    appdata () {
      // 提示用户是不是确认修改APP的信息
      const self = this
      self.$validator.validateAll({
        appName: self.appForm.appName,
        contactEmail: self.appForm.contactEmail,
        appNameShort: self.appForm.appNameShort,
        managerName: self.appForm.managerName,
        cellPhone: self.appForm.cellPhone,
        userEmails: self.appForm.userEmails
      }).then(result => {
        if (!result) { window.scrollTo(0,0);return }
        self.getLastMostForm()
      })
    },
    launchToast () {
      this.isToastContent = true
      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth
      })
      this.isToastContent = false
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    // 更新 商户秘钥
    getLastMerchantKey (keyStr, key) {
      const selfKey = this;
      selfKey.isShowMerchantPublicKeyTextarea = false
      let kindFg = 1
      let dStr = 'Security Key'
      if (keyStr === 'MerchantPrivateKey') {
        kindFg = 1
        dStr = 'Security Key'
      } else if (keyStr === 'MerchantPublicKey') {
        kindFg = 3
        dStr = 'Public Key'
      } else if (keyStr === 'MD5Key') {
        kindFg = 2
        dStr = 'MD5 Key'
      } else if (keyStr === 'MerchantRsaPublicKey') {
        kindFg = 4
        dStr = 'Merchant RSA Public Key'
        selfKey.isShowMerchantPublicKeyTextarea = true
      } else if (keyStr === 'PagsmileRsaPublicKey') {
        kindFg = 5
        dStr = `${process.env.VUE_APP_NAME} RSA Public Key`
      }
      selfKey.$confirm(
        'After updating the ' + dStr + ', please update it to your system as soon as possible, otherwise the system interface will not work properly.Are you sure you want to update the ' + dStr + '?',
        'warning',
        {
          confirmButtonText: 'confirm',
          cancelButtonText: 'cancel',
          type: 'warning'
        }
      )
        .then(() => {
          selfKey.$refs.passwordModal.open()
          selfKey.$validator.reset()
          selfKey.$refs.passwordModal.ok = () => {
            let validateObject = null
            if (keyStr === 'MerchantRsaPublicKey') {
              validateObject = {validPassword: selfKey.validatePasswordBean.password, validateMerchantPublicKey: selfKey.validatePasswordBean.merchantPublicKeyTextarea}
            } else {
              validateObject = {validPassword: selfKey.validatePasswordBean.password}
            }

            selfKey.$validator.validateAll(validateObject).then(async result => {
              if (!result) { return }
              await selfKey.getLastKey(keyStr, kindFg, key)
            })
          }
          selfKey.$refs.passwordModal.cancel = () => {
            selfKey.validatePasswordBean.password = ''
            selfKey.validatePasswordBean.merchantPublicKeyTextarea = ''
            selfKey.$refs.passwordModal.close()
          }
        })
        .catch(() => {
          selfKey.$message({
            type: 'info',
            message: 'Update canceled'
          })
        })
    },
    async getLastKey(keyStr, kindFg, key) {
      let token = localStorage.getItem('Authorization')
      let id = this.$route.params.app_id
      const param = {
        app_id: id,
        key_type: keyStr,
        key_value: this.validatePasswordBean.merchantPublicKeyTextarea.trim().replace('\\u200B', '')
      }
      let password = this.validatePasswordBean.password
      const formData = new FormData()
      formData.append( 'password', password )
      this.loadingFullScreen("configKeyLoading", "Loading", "fa fa-hourglass-half")
      const res = await request({
        method: 'post',
        url: `api/dashboard/app/keys/update?access_token=${token}`,
        params: param,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).catch(err => { this.toastText = err.msg; this.launchToast(); this.configKeyLoading.close(); })
      this.configKeyLoading.close();
      let { code, data, msg, sub_msg } = res.data
      if (code == 10000) {
        this.saveFg = true
        if (kindFg === 1) {
          this.appForm.securityKey = data
        } else if (kindFg === 3) {
          this.appForm.publicKey = data
        } else if (kindFg === 2) {
          this.appForm.md5Key = data
        } else if (kindFg === 4) {
          this.appForm.mRsaPublicKey = data
        } else if (kindFg === 5) {
          this.appForm.psPublicKey = data
        }
        this[key] = true;
        this.validatePasswordBean.password = ''
        this.validatePasswordBean.merchantPublicKeyTextarea = ''
        this.$refs.passwordModal.close()
        this.toastText = msg || 'Success!'
        this.launchToast()
      } else {
        this.toastText = `${msg}: ${sub_msg}`
        this.launchToast()
      }

    },
    showEyePassword(key, bool, k) {
      const that = this;
      if (that.appForm[k]) {
        that[key] = bool;
      } else {
        // console.log(this.$refs.passwordModal)
        this.$refs.passwordModal.open()
        this.$validator.reset()
        this.currentKey = key

        window.addEventListener("keyup", event => {
          if (event.keyCode === 13) {
            console.log(this.currentKey, key)
            if (this.currentKey !== key) { return }

            that.$validator.validateAll({validPassword: that.validatePasswordBean.password}).then(async (result) => {
              if (result) {
                await that.getConfigKey(key, bool, k)
              }
            })
          }
        }, false);

        this.$refs.passwordModal.ok = () => {
          that.$validator.validateAll({validPassword: that.validatePasswordBean.password}).then(async (result) => {
            if (result) {
              await that.getConfigKey(key, bool, k)
            }
          })
        }
        this.$refs.passwordModal.cancel = () => {
          // that[key] = bool;
          that.validatePasswordBean.password = ''
          that.validatePasswordBean.merchantPublicKeyTextarea = ''
          that.$refs.passwordModal.close()
        }
      }
    },
    async getConfigKey(key, bool, k) {
      let token = localStorage.getItem('Authorization')
      let id = this.$route.params.app_id
      let key_type = ''
      if (k === 'securityKey') {
        key_type = 'MerchantPrivateKey'
      } else if (k === 'md5Key') {
        key_type = 'MD5Key'
      } else if (k === 'publicKey') {
        key_type = 'MerchantPublicKey'
      } else if (k === 'mRsaPublicKey') {
        key_type = 'MerchantRsaPublicKey'
      } else if (k === 'psPublicKey') {
        key_type = 'PagsmileRsaPublicKey'
      }
      if (!this.validatePasswordBean.password) {
        return
      }
      let password = this.validatePasswordBean.password
      const formData = new FormData()
      formData.append( 'password', password )
      let that = this
      that.loadingFullScreen("configKeyLoading", "Loading", "fa fa-hourglass-half")
      const res = await request({
        method: 'post',
        url: `api/dashboard/app/keys/display?app_id=${id}&key_type=${key_type}&access_token=${token}`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData
      }).catch(err => { that.toastText = err.msg; that.launchToast(); that.configKeyLoading.close(); })
      that.configKeyLoading.close();
      const {code, data, msg, sub_msg} = res.data
      if (code === '10000') {
        const {mprivate_key, md5_key, mpublic_key, mrsa_public_key, ps_public_key } = data
        if (mprivate_key) { that.appForm.securityKey = mprivate_key; that[key] = bool; }
        if (md5_key) { that.appForm.md5Key = md5_key; that[key] = bool; }
        if (mpublic_key) { that.appForm.publicKey = mpublic_key; that[key] = bool; }
        if (mrsa_public_key) { that.appForm.mRsaPublicKey = mrsa_public_key; that[key] = bool; }
        if (ps_public_key) { that.appForm.psPublicKey = ps_public_key; that[key] = bool; }
        that.validatePasswordBean.password = ''
        that.validatePasswordBean.merchantPublicKeyTextarea = ''
        that.$refs.passwordModal.close();
        // that.$refs.passwordModal.$destroy();
        that.toastText = msg || 'Success!'
        that.launchToast()
      } else {
        that.toastText = `${msg}: ${sub_msg}`
        that.launchToast()
      }
    },
    copyText(value = '') {
      const that = this
			const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', value);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message({
          showClose: true,
          message: 'Copied Successfully',
          type: 'success',
          duration: 2500
        });
        that.isCopySuccess = true
        setTimeout(() => {
          that.isCopySuccess = false
        }, 1200);
      }
      document.body.removeChild(input);
		}
  }
}
</script>
<style lang="scss" scoped>
.emailsTextArea {
	width: 100%;
	height: auto;
	border: none;
	outline: none;
	font-size: 1rem;
	color: #333;
	box-sizing: border-box;
	padding: 0.4rem 0;
	border-bottom: 1px solid #fff;
}
.section-comfirm {
	margin: 0 auto;
	width: 400px;
	display: flex;
	justify-content: space-around;
}
/deep/ #selectWrapper {
	.form-group {
		min-height: 30px;
	}
	input[name="simple-select"] {
		height: 33px;
	}
	input.has-value {
		height: 28px !important;
	}
}
/deep/ .vuestic-widget {
	-webkit-box-shadow: 0 0 0 0;
	box-shadow: 0 0 0 0;
}
.form-group .control-label {
	position: absolute;
	top: -1rem;
}
form[name="fileUpload"] .form-group .control-label {
	position: absolute;
	top: 0.25rem;
}
::-webkit-input-placeholder {
	/* WebKit browsers */
	color: #999;
}
:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #999;
}
::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #999;
}
:-ms-input-placeholder {
	/* Internet Explorer 10+ */
	color: #999;
}
/deep/ #appInfoWrap.vuestic-widget {
	.vuestic-widget-body {
		padding-bottom: 0;
	}
}
/deep/ #fileShowWrapper.vuestic-widget {
	margin-bottom: 0;
	.vuestic-widget-body {
		padding-bottom: 0;
	}
}
/deep/ #appLogoShowWrapper.vuestic-widget {
	margin-bottom: 0;
	.vuestic-widget-body {
		padding-bottom: 0;
	}
}
.oneline {
	display: flex;
	justify-content: flex-start;
	.updateBtn {
		display: inline-block;
		width: 200px;
		height: 56px;
		margin-top: -14px;
	}
}
#btn-ico-wrapper {
	margin-left: 0;
	display: inline-flex;
	height: 24px;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}
.centerFont {
	padding-left: 6px;
	height: 26px;
	display: inline-flex;
	align-items: center;
	line-height: 0.5;
	margin-top: 6px;
}
/deep/ .btn.btn-with-icon {
	padding: 0.45rem 1rem;
	height: 42px;
	line-height: 30px;
	position: relative;
	top: 12px;
}
/deep/ .btn.btn-with-icon i {
	position: static;
	left: 0;
	top: 0;
	font-size: 20px;
	margin-top: 4px;
}
/deep/ #appLogoWrapper {
	.control-label {
		position: relative;
	}
}
/deep/ .file-upload-item {
	padding: 40px 0 0 0;
	.file-upload-item-image {
		border: 1px dashed #ccc;
		box-sizing: border-box;
		border-radius: 10px;
		height: 105px;
	}
}
/deep/ .vuestic-checkbox {
	.vuestic-checkbox__square {
		margin-left: 50px;
	}
	.vuestic-checkbox__label-text {
		margin-left: 0;
	}
}
#appInfoBackBtn {
	position: absolute;
	top: 146px;
	right: 80px;
}
.pic-desc > span {
  font-size: 18px;
	margin-right: 2px;
	line-height: 24px;
	display: inline-block;
	height: 24px;
}
@media only screen and (max-width: 750px) {
	/deep/ .vuestic-file-upload-container {
		width: 170px;
		height: 40px;
	}
	#appLogoWrapper {
		padding-right: 10px !important;
	}
	.oneline .btn-with-icon {
		padding: 0.45rem 1.8rem 0.8rem;
	}
	#confirmCreateApp,
	#cancelCreateApp {
		padding: 0.5rem 1rem;
	}
	.btn.btn-with-icon {
		position: absolute;
		top: 122px;
		left: 0;
		height: 36px;
	}
}
.eye-password-wrap {
  .eye-password {
    position: absolute;
    left: 50px;
    top: -18px;
    width: 25px;
    cursor: pointer;
    /deep/ img {
      width: 100%;
    }
  }
}
.eye-password-modal {
  .eye-password {
    position: absolute;
    top: 2px;
    right: 20px;
    width: 25px;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
    }
  }
}

/deep/ .password-key-modal {
  .modal-dialog {
    max-width: 400px;
  }
  .modal-body {
    padding-bottom: 0;
  }
}
</style>
